export default __webpack_public_path__ + "static/media/PB_Rewards_Mobile.ca28a7c8.png";